import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import config from '../config';

const createApiClient = (baseURL: string): AxiosInstance => {
  const client = axios.create({
    baseURL,
    timeout: 30000,
    headers: {
      'Content-Type': 'application/json',
    },
  });

  client.interceptors.request.use(
    (reqConfig: InternalAxiosRequestConfig) => {
      const token = localStorage.getItem('access_token');
      if (token && reqConfig.headers) {
        reqConfig.headers.Authorization = `Bearer ${token}`;
      }
      return reqConfig;
    },
    (error) => Promise.reject(error)
  );

  client.interceptors.response.use(
    (response) => response,
    async (error) => {
      if (error.response?.status === 401) {
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
      }
      return Promise.reject(error);
    }
  );

  return client;
};

export const userApi = createApiClient(config.userServiceUrl);
export const feedApi = createApiClient(config.feedServiceUrl);

export default { userApi, feedApi };
